export const APP_NAME = 'CribWiz';
export const APP_URL = process?.env?.MIX_APP_URL || 'https://cribwiz.com';
export const GMAP_API_KEY = 'AIzaSyDeGWyq3uECmOeQkl0g2mrmUoXlHgiqFvQ';
export const STATUS_ACTIVE = 1
export const STATUS_EXPIRED = 13
export const STATUS_REMOVED = -1
